import React from 'react';
import { useQuery } from '@apollo/client';
import ExternalBrandLogo from '../../components/ExternalBrandLogo';
import { gql } from '../../graphql/generated';
import getExternalBrandLogoProps from '../../integrations/getExternalBrandLogoProps';
import EDITOR_INTEGRATION_MENTIONS from '../mentions/EditorIntegrationMentions';
import EmbedFooter from './EmbedFooter';
import { EmbedMode, embedUrl } from './matchEmbed';

export const embedsWithNativeFooter = [
  'airtable',
  'figma',
  'google-calendar',
  'google-map',
  'lucidchart',
  'miro',
  'mode',
  'slideshare',
  'microsoft-office',
  'pitch',
  'tableau',
  'rows',
];

const GET_EMBED_QUERY = gql(/** @complexity 4 */ `
  query getEmbedFooter($type: MentionType!, $id: ID!) {
    mention(type: $type, id: $id) {
      id
      title
    }
  }
`);

interface ExternalEmbedFooterProps {
  id: string;
  type: string;
  params?: string;
  className?: string;
}

const ExternalEmbedFooter = ({
  id,
  type,
  params,
  className,
}: ExternalEmbedFooterProps) => {
  const mentionInfo = EDITOR_INTEGRATION_MENTIONS[type];
  const { data } = useQuery(GET_EMBED_QUERY, {
    // @ts-expect-error
    variables: { id, type: mentionInfo?.apiEnum },
    skip: !mentionInfo,
  });

  const link = embedUrl({ id, type, params }, EmbedMode.FULL) || '';
  const hasNativeFooter = embedsWithNativeFooter.includes(type);
  return (
    <EmbedFooter
      className={className}
      hasNativeFooter={hasNativeFooter}
      link={link}
      icon={
        <ExternalBrandLogo {...getExternalBrandLogoProps(type)} height={16} />
      }
      title={data?.mention.title || link}
    />
  );
};

export default ExternalEmbedFooter;
